import React, { useState, useEffect } from 'react';
import { useRef } from 'react';
import { ChevronLeft, ChevronRight, ShoppingBag, Calendar, MapPin, Gift, Search, Navigation, Locate, Activity, Utensils, Flame, Scale, Leaf } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Info } from 'lucide-react';
import { updateLocale } from 'moment/moment';
import { useNavigate } from 'react-router-dom';
import AddressLocationPicker from '../components/AddressLocationPicker';


const MealPlanner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedPlans = location.state?.selectedPlan;
  const [ishandleSelectMeals, setIshandleSelectMeals] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedDates, setSelectedDates] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
  const [formData, setFormData] = useState({
    streetName: "",
    isStreetManual: false,
    buildingName: "",
    flatNumber: "",
    landmark: "",
    city: "",
    phoneNumber: "",
    addressType: "home",
    latitude: null,
    longitude: null,
    location: "",
    address: ""
  });
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [selectedDate, setSelectedDate] = useState(null);
  const [mealData, setMealData] = useState([]);
  const [selectedEnhancements, setSelectedEnhancements] = useState([]);
  const [selectedPackageId, setSelectedPackageId] = useState(null);
  // New state to track selected meals for each day
  const [selectedMeals, setSelectedMeals] = useState({});
  const [activeStep, setActiveStep] = useState(1);

  // Map-related state
  const [mapCenter, setMapCenter] = useState({ lat: 25.276987, lng: 55.296249 }); // Dubai default
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [isProcessingLocation, setIsProcessingLocation] = useState(false);
  const [pinnedLocations, setPinnedLocations] = useState([]);
  const [isLoadingAddress, setIsLoadingAddress] = useState(false);
  const [showPinnedLocations, setShowPinnedLocations] = useState(false);

  // Function to get address from coordinates using Google Maps Geocoding API
  const getAddressFromCoordinates = async (lat, lng) => {
    try {
      setIsLoadingAddress(true);
      const mapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyCexl3SGUt4zgx79N-31YKxbjrqJd2HhwA";
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${mapsApiKey}`
      );
      const data = await response.json();

      if (data.results && data.results.length > 0) {
        const address = data.results[0].formatted_address;
        // Extract street name from address components
        let streetName = '';
        const streetComponent = data.results[0].address_components.find(
          component => component.types.includes('route')
        );
        if (streetComponent) {
          streetName = streetComponent.long_name;
        }

        setFormData(prev => ({
          ...prev,
          location: address,
          street: prev.isStreetManual ? prev.street : (streetName || address),
          latitude: lat,
          longitude: lng,
          // Don't override isStreetManual here to preserve manual edits
        }));

        // Add to pinned locations
        setPinnedLocations(prev => [
          ...prev,
          { lat, lng, address, street: streetName || address }
        ]);
      }
    } catch (error) {
      console.error('Error fetching address:', error);
      toast.error('Failed to fetch address. Please try again.');
    } finally {
      setIsLoadingAddress(false);
    }
  };

  // Add effect to log form data changes
  useEffect(() => {
    console.log('Form data updated:', formData);
  }, [formData]);

  // Handle location selection from map click or search
  const handleMapClick = (location) => {
    try {
      if (!location) {
        console.error('No location data received');
        return;
      }

      // Extract coordinates and address components from the location object
      let lat, lng, address, streetName, city, state;

      console.log(location, "ppppppp")

      // Handle different location data structures
      if (location.lat !== undefined && location.lng !== undefined) {
        // From map click or search with address components
        lat = location.lat;
        lng = location.lng;
        address = location.address || location.location;

        // Extract address components if available
        if (location.streetName || location.city || location.state) {
          streetName = location.streetName || '';
          city = location.city || '';
          state = location.state || '';
        } else if (address) {
          // Fallback: try to parse address string
          const parts = address.split(',').map(p => p.trim());
          streetName = parts[0] || '';
          if (parts.length > 1) city = parts[parts.length - 2] || '';
        }
      }
      // Handle Google Maps LatLng object
      else if (location.latLng && typeof location.latLng.lat === 'function') {
        lat = location.latLng.lat();
        lng = location.latLng.lng();
      }

      // If we still don't have coordinates, try to parse them from the form data
      if ((lat === undefined || lng === undefined) && formData.latitude && formData.longitude) {
        lat = formData.latitude;
        lng = formData.longitude;
      }

      if (lat === undefined || lng === undefined) {
        console.error('Could not extract coordinates from:', location);
        return;
      }

      // Ensure we have valid numbers
      lat = parseFloat(lat);
      lng = parseFloat(lng);

      if (isNaN(lat) || isNaN(lng)) {
        console.error('Invalid coordinates:', { lat, lng });
        return;
      }

      // Update the form data with the new location information
      setFormData(prev => {
        // Only update street name if it hasn't been manually edited
        const updatedStreetName = prev.isStreetManual ? prev.streetName : (streetName || (address ? address.split(',')[0].trim() : prev.streetName));

        return {
          ...prev,
          latitude: lat,
          longitude: lng,
          location: address || prev.location,
          streetName: updatedStreetName,
          city: city || prev.city,
          state: state || prev.state,
          // Don't reset isStreetManual here to preserve manual edits
        };
      });

      // If we don't have an address yet, fetch it
      if (!address) {
        getAddressFromCoordinates(lat, lng);
      } else {
        // Show success message
        toast.success('Location selected!');

        // Add to pinned locations if it's a new location
        if (!pinnedLocations.some(loc => loc.lat === lat && loc.lng === lng)) {
          setPinnedLocations(prev => [
            ...prev,
            {
              lat,
              lng,
              address,
              street: streetName || (address ? address.split(',')[0].trim() : '')
            }
          ]);
        }
      }

    } catch (error) {
      console.error('Error in handleMapClick:', error);
      toast.error('Failed to process location. Please try again.');
    }
  };

  const plans = [
    "MONTHLY (6 days per week)",
    "MONTHLY (5 days per week)",
    "WEEKLY (6 days)",
    "WEEKLY (5 days)"
  ];


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleStreetNameChange = (e) => {
    const { value } = e.target;
    setFormData(prev => ({
      ...prev,
      streetName: value,
      isStreetManual: true // Mark as manually edited
    }));
  };


  // Location handling functions
  const handleMapLocationSelect = (locationData) => {
    // Only update the fields that haven't been manually edited
    setFormData(prev => {
      // If street was manually edited, keep the manual value
      const streetName = prev.isStreetManual ? prev.streetName : (locationData.streetName || '');

      return {
        ...prev,
        latitude: locationData.latitude,
        longitude: locationData.longitude,
        location: locationData.location || prev.location,
        streetName: streetName,
        city: locationData.city || prev.city,
        state: locationData.state || prev.state,
        // Only update isStreetManual if it hasn't been manually set
        ...(prev.isStreetManual ? {} : { isStreetManual: false })
      };
    });

    // Show success message when location is selected
    toast.success("Location selected successfully!", {
      position: "top-right",
      autoClose: 2000,
    });

    // Reset processing state after a short delay
    setTimeout(() => {
      setIsProcessingLocation(false);
    }, 1000);
  };

  const handleLocationSelect = (location) => {
    setIsProcessingLocation(true);

    setFormData(prev => ({
      ...prev,
      latitude: location.latitude,
      longitude: location.longitude,
      location: location.location,
      street: location.location, // Show the complete selected location
    }));

    // Show success message when location is selected
    toast.success("Location selected successfully!", {
      position: "top-right",
      autoClose: 2000,
    });

    // Reset processing state after a short delay
    setTimeout(() => {
      setIsProcessingLocation(false);
    }, 1000);
  };

  // Auto-fetch current location for mobile
  const getCurrentLocation = () => {
    if (!navigator.geolocation) {
      toast.error("Geolocation is not supported by this browser.");
      return;
    }

    toast.info("Getting your current location...", {
      position: "top-right",
      autoClose: 3000,
    });

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        setFormData(prev => ({
          ...prev,
          latitude: latitude,
          longitude: longitude,
        }));

        // Reverse geocode to get address
        if (window.google && window.google.maps) {
          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode(
            { location: { lat: latitude, lng: longitude } },
            (results, status) => {
              if (status === 'OK' && results[0]) {
                const address = results[0].formatted_address;

                setFormData(prev => ({
                  ...prev,
                  location: address,
                  street: address, // Show the complete selected location
                }));
                toast.success("Location detected successfully!");
              }
            }
          );
        }
      },
      (error) => {
        console.error("Error getting location:", error);
        let errorMessage = "Unable to get your location. ";
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage += "Please allow location access and try again.";
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage += "Location information is unavailable.";
            break;
          case error.TIMEOUT:
            errorMessage += "Location request timed out.";
            break;
          default:
            errorMessage += "An unknown error occurred.";
            break;
        }
        toast.error(errorMessage);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 60000
      }
    );
  };

  // Auto-fetch location on mobile when case 4 is reached
  useEffect(() => {
    if (activeStep === 4 && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      // Small delay to ensure the component is fully rendered
      const timer = setTimeout(() => {
        getCurrentLocation();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [activeStep]);

  const handleAddressSubmit = async (e) => {
    if (e) {
      e.preventDefault();
    }

    // Validate location is selected
    if (!formData.latitude || !formData.longitude) {
      toast.error("Please select your location on the map before submitting.", {
        position: "top-right",
        autoClose: 5000,
      });
      return false;
    }

    try {
      const { isStreetManual, location, street, address, ...filteredData } = formData;
      const payload = { address: filteredData };
      console.log("Submitting address payload:", payload);

      // Show loading state
      const toastId = toast.loading("Adding address...", { position: "top-right" });

      const response = await axios.post(
        "https://api.dailyfit.ae/api/user/add-address",
        payload,
        {
          withCredentials: true,
          timeout: 10000, // 10 second timeout
          headers: {
            "Content-Type": "application/json",
          },
        }
      );


      // Update loading toast to success
      toast.update(toastId, {
        render: "Address added successfully!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      console.log("Response:", response.data);
      return true;

    } catch (error) {
      console.error("Error:", error);

      // Show error toast
      toast.error(
        error.response?.data?.message || "Failed to add address. Please try again.",
        {
          position: "top-right",
          autoClose: 5000,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );

      return false;
    }
  };

  const [selectedPackage, setSelectedPackage] = useState({
    packageId: null,
    planId: null
  });

  const isSelected = (packageId, planId) => {
    return selectedPackage.packageId === packageId && selectedPackage.planId === planId;
  };

  const saveSelectionsToSessionStorage = () => {
    const formData = {
      items: sessionStorage.getItem('cartItems') ? JSON.parse(sessionStorage.getItem('cartItems')) : [],
      shippingAddress: sessionStorage.getItem('shippingAddress') ? JSON.parse(sessionStorage.getItem('shippingAddress')) : {},
      paymentMethod: sessionStorage.getItem('paymentMethod') || ''
    };
  };
  const [addons, setAddons] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get("https://api.dailyfit.ae/api/user/get-addons", { withCredentials: true });
        setAddons(response.data.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
    fetchMealTypes();
  }, []);

  const handleSelection = async (packageId, identifierPackage) => {


    setSelectedPackageId(packageId);
    sessionStorage.setItem("package", packageId);

    try {
      const response = await axios.post(
        "https://api.dailyfit.ae/api/user/get-package-details",
        {
          "id": identifierPackage
        },
        { withCredentials: true }
      );


      if (response.data.data) {
        console.log(response.data.data, "The data api response")
        const packages = response.data.data;
        console.log(packages, "The packages")
        const formattedMeals = {};

        const packageList = Array.isArray(packages) ? packages : [packages];

        packageList.forEach((pkg) => {
          if (pkg.meals && typeof pkg.meals === 'object') {
            Object.entries(pkg.meals).forEach(([day, dayData]) => {
              if (dayData.date) {
                const date = dayData.date.includes('T') ? dayData.date.split('T')[0] : dayData.date;

                console.log(`\n=== DAY: ${day} | DATE: ${date} ===`);
                console.log('dayData.meals refs:', JSON.stringify(dayData.meals?.map(m => ({ meal: m.meal, mealType: m.mealType }))));

                let resolvedMealsList = [];
                if (dayData.mealsDetails && dayData.mealsDetails.length > 0) {
                  resolvedMealsList = dayData.mealsDetails.map(detail => {
                    // Find the meal ref entry that matches this detail
                    const config = dayData.meals ? dayData.meals.find(m =>
                      String(m.meal) === String(detail._id) ||
                      String(m.mealId) === String(detail._id) ||
                      (m.meal && String(m.meal._id || m.meal) === String(detail._id))
                    ) : null;

                    // Get the mealType from the ref (most reliable source)
                    // Flatten any nesting: [[id]] → [id], filter empty strings
                    const extractValidTypes = (raw) => {
                      if (!raw) return [];
                      const flat = Array.isArray(raw)
                        ? (raw.flat ? raw.flat(Infinity) : [].concat(...raw))
                        : [raw];
                      return flat.filter(t => t && String(t).trim() !== '');
                    };

                    let resolvedMealType = [];
                    // Try config.mealType first (from the ref), then fall back to detail.mealType
                    if (config && config.mealType) {
                      resolvedMealType = extractValidTypes(config.mealType);
                    }
                    // If config gave us empty types, try the meal document's own mealType
                    if (resolvedMealType.length === 0 && detail.mealType) {
                      resolvedMealType = extractValidTypes(detail.mealType);
                    }
                    // resolvedMealType may still be [] if backend has no mealType — that's OK
                    // meals with [] mealType will be shown under all slots (see getMealsByType)

                    console.log(`  meal "${detail.mealName}" mealType:`, JSON.stringify(resolvedMealType));

                    return { ...detail, mealType: resolvedMealType };
                  });
                } else if (dayData.meals && dayData.meals.length > 0) {
                  resolvedMealsList = dayData.meals;
                }

                if (resolvedMealsList.length > 0) {
                  const processedMeals = resolvedMealsList.map(meal => ({
                    ...meal,
                    image: meal.image && Array.isArray(meal.image) ? meal.image : ['/placeholder-image.jpg']
                  }));
                  formattedMeals[date] = processedMeals;
                }
              }
            });
          }
        });

        setMealData(formattedMeals);
        //  alert(JSON.stringify(formattedMeals))

        const availableDates = Object.keys(formattedMeals);

        if (availableDates.length > 0) {
          setSelectedDate(availableDates[0]);

          // Initialize selected meals with first product for each day
          const initialSelectedMeals = {};
          availableDates.forEach(date => {
            if (formattedMeals[date] && formattedMeals[date].length > 0) {
              // Initialize with the first meal object for the date (keep shape consistent: array of meal objects)
              // Give the initial selected meal a selectedSlot equal to its primary mealType (if available)
              const first = formattedMeals[date][0];
              let resolvedSlot = 'primary';
              if (Array.isArray(first.mealType) && first.mealType.length > 0) {
                resolvedSlot = resolveMealType(first.mealType[0]);
              } else if (first.mealType) {
                resolvedSlot = resolveMealType(first.mealType);
              }
              initialSelectedMeals[date] = [{
                ...first,
                selectedSlot: resolvedSlot
              }];
            }
          });

          setSelectedMeals(initialSelectedMeals);
        }
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };
  const formatDate = (dateObj) => {
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const [mealType, setMealType] = useState([]);
  const fetchMealTypes = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.get("https://api.dailyfit.ae/api/user/get-mealtype", { withCredentials: true });
      setMealType(response.data.data);
      console.log('🟡 MEALTYPE LIST:', response.data.data?.map(t => ({ _id: t._id, id: t.id, identifier: t.identifier, mealType: t.mealType })));

    } catch (error) {
      console.error("Error fetching meal types:", error);
    }
  };
  // 👇 Place this at the top of your component (not inside getMealsByType)
  const autoSelectRef = useRef({}); // Keeps track of which (date+type) was auto-selected

  const resolveMealType = (mt) => {
    if (!mt) return '';
    // ✅ Handle nested arrays: [["id"]] → resolve each element
    if (Array.isArray(mt)) {
      const flat = mt.flat ? mt.flat(Infinity) : [].concat(...mt);
      for (const item of flat) {
        const resolved = resolveMealType(item);
        if (resolved) return resolved;
      }
      return '';
    }
    if (typeof mt === 'string') {
      const matched = mealType.find(t => 
        (t._id && String(t._id) === String(mt)) || 
        (t.identifier && String(t.identifier).toLowerCase() === String(mt).toLowerCase()) || 
        (t.mealType && String(t.mealType).toLowerCase() === String(mt).toLowerCase()) ||
        (t.id && String(t.id) === String(mt))
      );
      return matched ? matched.identifier : mt;
    }
    if (typeof mt === 'object') {
      if (mt.identifier) return mt.identifier;
      if (mt.mealType) {
        const matched = mealType.find(t => 
          (t.mealType && String(t.mealType).toLowerCase() === String(mt.mealType).toLowerCase()) || 
          (t.identifier && String(t.identifier).toLowerCase() === String(mt.mealType).toLowerCase())
        );
        if (matched) return matched.identifier;
      }
      if (mt._id) {
        const matched = mealType.find(t => 
          (t._id && String(t._id) === String(mt._id)) || 
          (t.id && String(t.id) === String(mt._id))
        );
        return matched ? matched.identifier : mt._id;
      }
    }
    return String(mt);
  };

  const getMealsByType = (typeIdentifier) => {

    if (!selectedDate) {
      console.warn("No selected date set!");
      return [];
    }

    const localSelectedForDate = Array.isArray(selectedMeals[selectedDate])
      ? [...selectedMeals[selectedDate]]
      : [];

    const availableDates = Object.keys(mealData);
    console.log("Available dates in mealData:", availableDates);

    const matchedDate = availableDates.find((d) => d === selectedDate);
    if (!matchedDate) {
      console.warn(`Selected date '${selectedDate}' does not match any keys in mealData!`);
      return [];
    }

    const mealsForDate = mealData[matchedDate];
    console.log(`Total meals for matched date '${matchedDate}':`, mealsForDate.length);

    const allMealTypes = mealsForDate.map((m) => m.mealType);
    console.log("Meal types for this date:", allMealTypes);
    console.log('🔴 RAW first meal mealType (JSON):', JSON.stringify(mealsForDate[0]?.mealType));
    console.log('🔴 mealType state identifiers:', mealType?.map(t => ({ _id: t._id, identifier: t.identifier })));


    // 🔹 Filter meals by mealType — match by identifier, _id, or fallback (no type = show everywhere)
    const mealsOfType = mealsForDate.filter((meal) => {
      const rawType = meal.mealType;

      // ✅ FALLBACK: meal has no mealType assigned in backend → show under ALL slots
      const hasNoType = !rawType ||
        (Array.isArray(rawType) && rawType.length === 0) ||
        (Array.isArray(rawType) && rawType.every(t => !t || String(t).trim() === ''));

      if (hasNoType) return true; // show this meal regardless of which slot we're rendering

      const flatTypes = Array.isArray(rawType)
        ? (rawType.flat ? rawType.flat(Infinity) : [].concat(...rawType))
        : [rawType];

      return flatTypes.some((mt) => {
        if (!mt || String(mt).trim() === '') return false;
        const mtStr = String(mt).trim();
        // Direct identifier match
        if (mtStr.toLowerCase() === typeIdentifier.toLowerCase()) return true;
        // Look up by _id in mealType list → get identifier → compare
        const looked = mealType.find(t =>
          (t._id && String(t._id) === mtStr) ||
          (t.id && String(t.id) === mtStr)
        );
        if (looked) {
          return looked.identifier?.toLowerCase() === typeIdentifier.toLowerCase();
        }
        return false;
      });
    });

    // 🔹 Auto-select only the first meal of this type ONCE per date+type
    const autoSelectKey = `${matchedDate}-${typeIdentifier}`;

    if (ishandleSelectMeals == null && mealsOfType.length > 0) {
      const firstMeal = mealsOfType[0];
      const alreadySelected = localSelectedForDate.some(
        (m) => m._id === firstMeal._id && m.mealType?.includes(typeIdentifier)
      );

      if (!alreadySelected && !autoSelectRef.current[autoSelectKey]) {
        autoSelectRef.current[autoSelectKey] = true; // prevent repeated auto-selections

        setTimeout(() => {
          setSelectedMeals((prev) => {
            const updated = Array.isArray(prev[matchedDate]) ? [...prev[matchedDate]] : [];

            // ✅ Check if a meal for this type already exists
            const existingIndex = updated.findIndex((m) =>
              m.mealType?.includes(typeIdentifier)
            );

            if (existingIndex === -1) {
              // Add new entry with only this type
              updated.push({
                ...firstMeal,
                mealType: [typeIdentifier], // store this type only
              });
            } else {
              // Replace existing meal for this type
              updated[existingIndex] = {
                ...firstMeal,
                mealType: [typeIdentifier],
              };
            }

            console.log(
              `✅ Auto-selected '${firstMeal.mealName}' for type '${typeIdentifier}'`
            );

            return { ...prev, [matchedDate]: updated };
          });
        }, 0);
      }
    }

    console.log(
      "Currently selected meals for this date:",
      Array.isArray(selectedMeals[matchedDate])
        ? selectedMeals[matchedDate].map((m) => ({
          id: m._id,
          type: m.mealType,
        }))
        : selectedMeals[matchedDate]
    );

    return mealsOfType;
  };



  // Function to capitalize first letter of each word
  const capitalize = (str) => {
    return str.replace(/\b\w/g, char => char.toUpperCase());
  };

  const handleDateSelection = (date) => {
    console.log('Raw selected date:', date);

    // Strip time part completely to avoid timezone shifting
    const cleanDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const selectedDateStr = formatDate(cleanDate);

    if (isDateDisabled(cleanDate)) {
      console.log('Date is disabled');
      return;
    }

    if (selectedDates.includes(selectedDateStr)) {
      setSelectedDates([]);
      setSelectedDate(null);
      sessionStorage.removeItem('startDate');
      sessionStorage.removeItem('endDate');
      return;
    }

    let newSelectedDates = [];

    if (selectedPlan?.includes("MONTHLY")) {
      const daysToSelect = selectedPlan.includes("5 days") ? 20 : 24;
      let currentDate = new Date(cleanDate);
      let validDates = [];

      while (validDates.length < daysToSelect) {
        const dateStr = formatDate(currentDate);
        if (!isDateDisabled(currentDate)) {
          validDates.push(dateStr);
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }

      newSelectedDates = validDates;
      sessionStorage.setItem('startDate', validDates[0]);
      sessionStorage.setItem('endDate', validDates[validDates.length - 1]);

    } else if (selectedPlan?.includes("WEEKLY")) {
      const daysToSelect = selectedPlan.includes("5 days") ? 5 : 6;
      let currentDate = new Date(cleanDate);
      let validDates = [];

      while (validDates.length < daysToSelect) {
        const dateStr = formatDate(currentDate);
        if (!isDateDisabled(currentDate)) {
          validDates.push(dateStr);
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }

      newSelectedDates = validDates;
      sessionStorage.setItem('startDate', validDates[0]);
      sessionStorage.setItem('endDate', validDates[validDates.length - 1]);

    } else {
      // One-day selection fallback
      newSelectedDates = [selectedDateStr];
      sessionStorage.setItem('startDate', selectedDateStr);
      sessionStorage.setItem('endDate', selectedDateStr);
    }

    console.log("✅ Final date range selected:", newSelectedDates);

    // Auto-select first meal of each type for each selected date
    const updatedSelectedMeals = { ...selectedMeals };

    newSelectedDates.forEach(dateStr => {
      if (mealData[dateStr]) {
        // Auto-select first meal for each defined slot (type.identifier) rather than using meal.mealType[0]
        // Initialize meals array for this date (clear existing selections for this date)
        updatedSelectedMeals[dateStr] = [];

        // If we have a global mealType list (slots), iterate over it to pick the first matching meal for each slot
        if (Array.isArray(mealType) && mealType.length > 0) {
          mealType.forEach(slot => {
            const slotIdentifier = slot.identifier;
            // Find the first meal for this date that lists this slot identifier in its mealType array
            const firstMealOfSlot = mealData[dateStr].find(meal => {
              if (Array.isArray(meal.mealType)) {
                return meal.mealType.some(mt => resolveMealType(mt).toLowerCase() === String(slotIdentifier).toLowerCase());
              } else if (meal.mealType) {
                return resolveMealType(meal.mealType).toLowerCase() === String(slotIdentifier).toLowerCase();
              }
              return false;
            });

            if (firstMealOfSlot) {
              // Only add if slot not already filled
              if (!updatedSelectedMeals[dateStr].some(m => m.selectedSlot === slotIdentifier)) {
                updatedSelectedMeals[dateStr].push({ ...firstMealOfSlot, selectedSlot: slotIdentifier });
                console.log(`Auto-selected slot ${slotIdentifier}:`, firstMealOfSlot.mealName, 'for date:', dateStr);
              }
            }
          });
        } else {
          // Fallback: if no slot definitions, pick the first meal of each unique primary type found in data
          const primaryTypes = new Set();
          mealData[dateStr].forEach(meal => {
            const mType = Array.isArray(meal.mealType) ? meal.mealType[0] : meal.mealType;
            if (mType) {
              primaryTypes.add(resolveMealType(mType));
            }
          });
          primaryTypes.forEach(type => {
            const firstMealOfType = mealData[dateStr].find(meal => {
              const mType = Array.isArray(meal.mealType) ? meal.mealType[0] : meal.mealType;
              return mType && resolveMealType(mType) === type;
            });
            if (firstMealOfType) {
              updatedSelectedMeals[dateStr].push({ ...firstMealOfType, selectedSlot: type });
            }
          });
        }
      }
    });

    setSelectedMeals(updatedSelectedMeals);
    setSelectedDates(newSelectedDates);
    setSelectedDate(newSelectedDates[0]);
  };

  const isDateDisabled = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const twoDaysFromNow = new Date(today);
    twoDaysFromNow.setDate(today.getDate() + 2);

    if (date <= twoDaysFromNow) return true;
    if (selectedPlan?.includes("5 days") && (date.getDay() === 0 || date.getDay() === 6)) return true;
    if (selectedPlan?.includes("6 days") && date.getDay() === 0) return true;

    return false;
  };

  // New function to handle meal selection
  const handleMealSelection = (date, meal, mealTypeIdentifier) => {
    console.log(mealTypeIdentifier, "mealType Selected")
    setIshandleSelectMeals(1)
    console.log("📦 Selected meal:", meal, "for date:", date, "with type identifier:", mealTypeIdentifier);

    // Get current meals for the date or initialize with an empty array
    // Use functional state update to avoid direct mutation and ensure
    // comparisons consider the full mealType arrays (meals can have multiple types)
    setSelectedMeals(prev => {
      const currentMeals = Array.isArray(prev[date]) ? [...prev[date]] : [];

      // find if this slot (meal type) already has a meal
      const overlappingIndex = currentMeals.findIndex(
        existingMeal => existingMeal.selectedSlot === mealTypeIdentifier
      );

      //  create a filtered copy of the meal so only the chosen type stays
      const filteredMeal = {
        ...meal,
        mealType: [mealTypeIdentifier],
        selectedSlot: mealTypeIdentifier
      };

      // if no meal exists for this type, add it
      if (overlappingIndex === -1) {
        if (!currentMeals.some(m => m._id === meal._id && m.selectedSlot === mealTypeIdentifier)) {
          currentMeals.push(filteredMeal);
        }
      } else {
        // otherwise, replace the existing meal in that slot
        currentMeals[overlappingIndex] = filteredMeal;
      }

      return {
        ...prev,
        [date]: currentMeals
      };
    });


    console.log('Updated selectedMeals for', date, selectedMeals[date]);
  };







  const handleResetSelections = () => {
    setSelectedOptions({});
    setSelectedPlan(null);
    setSelectedDates([]);
    setSelectedMeals({});

    sessionStorage.removeItem('startDate');
    sessionStorage.removeItem('endDate');
    sessionStorage.removeItem('selectedMeals');
  };

  const renderCalendar = (monthOffset) => {
    const month = new Date(currentYear, currentMonth + monthOffset, 1);
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const daysInMonth = new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate();
    const firstDayOfMonth = new Date(month.getFullYear(), month.getMonth(), 1).getDay();

    const calendarDays = [];
    for (let i = 0; i < firstDayOfMonth; i++) {
      calendarDays.push(<div key={`empty-${i}`} className="w-10 h-10" />);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(month.getFullYear(), month.getMonth(), day);
      const dateStr = date.toLocaleDateString('en-CA').split('T')[0];
      const isDisabled = isDateDisabled(date);
      const isSelected = selectedDates.includes(dateStr);
      console.log({
        day,
        dateStr,
        isSelected,
        selectedDates,
      });

      calendarDays.push(
        <button
          key={`${month.getMonth()}-${day}`}
          onClick={() => handleDateSelection(date)}
          disabled={isDisabled}
          className={`w-10 h-10 rounded-full text-sm font-medium transition-colors
            ${isDisabled
              ? "text-gray-300 cursor-not-allowed"
              : isSelected
                ? "bg-gradient-to-r from-emerald-500 to-teal-500 text-white shadow-md"
                : "hover:bg-emerald-50 hover:text-emerald-600"
            }`}
        >
          {day}
        </button>
      );
    }

    return (
      <div className=" lg:w-[50%] sm:w-full xs:w-60 h-auto  rounded-lg ">
        <h3 className="text-lg font-medium mb-4 text-gray-800">
          {month.toLocaleDateString('default', { month: 'long', year: 'numeric' })}
        </h3>
        <div className="grid grid-cols-7 gap-1 mb-2 ">
          {days?.map(day => (
            <div key={day} className="w-10 h-10 flex items-center justify-center text-sm font-medium text-gray-500">
              {day}
            </div>
          ))}
        </div>
        <div className="grid grid-cols-7 gap-1">
          {calendarDays}
        </div>
      </div>
    );
  };

  const handleNextMonth = () => {
    if (currentMonth === 11) {
      setCurrentMonth(0);
      setCurrentYear(currentYear + 1);
    } else {
      setCurrentMonth(currentMonth + 1);
    }
  };

  const handlePrevMonth = () => {
    if (currentMonth === 0) {
      setCurrentMonth(11);
      setCurrentYear(currentYear - 1);
    } else {
      setCurrentMonth(currentMonth - 1);
    }
  };
  const handleCompleteOrder = async () => {
    // alert("uiam in ")
    const packageId = sessionStorage.getItem("package");
    const startDate = sessionStorage.getItem("startDate");
    const endDate = sessionStorage.getItem("endDate");
    const planId = sessionStorage.getItem("plan");
    const selectedMealsFromStorage = sessionStorage.getItem("selectedProducts");

    // alert(packageId, startDate, endDate, planId, selectedMealsFromStorage)

    if (!packageId || !startDate || !endDate) {
      alert("Missing required order details. Please check your selections.");
      return;
    }

    // Parse the stored selectedMeals JSON
    let parsedSelectedMeals;
    try {
      parsedSelectedMeals = JSON.parse(selectedMealsFromStorage);
    } catch (error) {
      console.error("Error parsing selectedProducts from sessionStorage:", error);
      alert("Error with meal selection data. Please try again.");
      return;
    }

    // Extract just the selectedMeals array from the parsed object
    // The structure in storage has an extra wrapper object with selectedMeals key
    const transformData = (selectedMealsObj) => {
      return selectedMealsObj.map(entry => {
        // If "meals" exists and is an array, extract _id and mealType
        const meals = Array.isArray(entry.meals)
          ? entry.meals.map(meal => ({
            _id: meal._id,
            // mealType is always an array containing only the selected slot
            mealType: meal.selectedSlot ? [meal.selectedSlot] : (Array.isArray(meal.mealType) ? [meal.mealType[0]] : [meal.mealType]),
            mealName: meal.mealName,
            mealdescription: meal.mealdescription,
            calories: meal.calories,
            image: Array.isArray(meal.image) && meal.image.length > 0 ? meal.image[0] : '/placeholder-image.jpg',
            mealTypeDetails: meal.mealTypeDetails || {},
            fareDetails: meal.fareDetails || {}
          }))
          : [];

        return {
          date: entry.date,
          meals,
        };
      });
    };


    // Transforming the selectedMeals




    const mealsArray = parsedSelectedMeals.selectedMeals || [];
    console.log(mealsArray, 'meals arrayyyyyyyyy')
    const transformedData = transformData(mealsArray);
    console.log(transformedData, 'transformed data')


    // Extract just the ID part if it's in the format 'name-id'
    const extractId = (id) => {
      if (!id) return '';
      const parts = id.split('-');
      return parts[parts.length - 1]; // Return the last part which should be the ID
    };

    const payload = {
      package: extractId(packageId),
      startDate: startDate,
      endDate: endDate,
      selectedMeals: transformedData,
      plan: extractId(planId)
    };

    console.log(payload, 'cart payload');

    try {
      const response = await axios.post("https://api.dailyfit.ae/api/user/add-to-cart", payload, { withCredentials: true });
      toast.success('Successfully Completed your order! wait for Payment')
      if (response) {
        console.log(response)
        window.location.href = '/summary';
      }


      console.log("Response:", response.data.data);
    } catch (error) {
      alert("Failed to complete order. Please try again.");
      console.error("Error:", error);
    }
  };
  useEffect(() => {
    if (selectedDates.length > 0 && !selectedDate) {
      setSelectedDate(selectedDates[0]);
    }
  }, [selectedDates, selectedDate]);

  // Load saved selections from session storage on component mount
  useEffect(() => {
    const savedMeals = sessionStorage.getItem("selectedMeals");
    if (savedMeals) {
      setSelectedMeals(JSON.parse(savedMeals));
    }
  }, []);

  // Function to handle removing an add-on
  const handleRemoveAddOn = (item) => {
    const updatedSelections = selectedEnhancements.filter(
      (selected) => selected._id !== item._id
    );
    setSelectedEnhancements(updatedSelections);
  };

  // Function to handle initial selection of an add-on
  const handleSelectionAddOn = (item) => {
    const newItem = { ...item, quantity: 1 };
    setSelectedEnhancements([...selectedEnhancements, newItem]);
  };

  // Function to handle quantity change
  const handleQuantityChange = (item, newQuantity) => {
    const updatedSelections = selectedEnhancements?.map((selected) =>
      selected._id === item._id
        ? { ...selected, quantity: newQuantity }
        : selected
    );
    setSelectedEnhancements(updatedSelections);
  };

  // Function to handle confirming add-ons
  const handleConfirmAddOns = async () => {
    try {
      // Create array with duplicated IDs based on quantity
      const addOnIds = [];
      selectedEnhancements.forEach(item => {
        // Add the ID multiple times based on quantity
        for (let i = 0; i < item.quantity; i++) {
          addOnIds.push(item._id);
        }
      });

      // Make API call using axios
      const response = await axios.patch('https://api.dailyfit.ae/api/user/update-addons', {
        addOns: addOnIds
      }, { withCredentials: true });

      // Handle successful response
      console.log('Add-ons updated successfully:', response.data);
      toast.success('Successfully Added your Addons!')
      setTimeout(() => {
        setActiveStep(4);
      }, 1000)
    } catch (error) {
      console.error('Error updating add-ons:', error.response ? error.response.data : error.message);
    }
  };


  const handleSkip = async () => {
    try {
      const response = await axios.patch('https://api.dailyfit.ae/api/user/update-addons', {
        addOns: []
      }, { withCredentials: true });
      console.log('API success:', response.data);
      setActiveStep(4); // move to step 4
    } catch (error) {
      console.error('API error:', error);
      // optional: show error to user
    }
  };

  // Step indicators component
  const [showNutritionDetails, setShowNutritionDetails] = useState({});
  const [selectedMealForDetails, setSelectedMealForDetails] = useState(null);
  useEffect(() => {
    console.log("🟢 selectedMeals updated", selectedMeals);
  }, [selectedMeals]);


  const toggleNutritionDetails = (meal, e) => {
    e.stopPropagation(); // Prevent triggering the card selection
    setShowNutritionDetails(prev => ({
      ...prev,
      [meal._id]: !prev[meal._id]
    }));
    // Store the selected meal's details when opening the modal
    if (!showNutritionDetails[meal._id]) {
      setSelectedMealForDetails(meal);
    }
  };
  const handleContinue = () => {
    if (!selectedPackageId || !selectedPlan || selectedDates.length === 0) {
      toast.error("Please complete all selections before continuing.");
      return;
    }

    toast.success("Plan created successfully");

    setTimeout(() => {
      setActiveStep(2); // <-- ✅ Use setActiveStep instead of setStep
    }, 1000);
  };

  const StepIndicator = ({ step, title, icon }) => {
    const Icon = icon;
    return (

      <div className={`flex flex-col items-center ${activeStep >= step ? 'text-emerald-600' : 'text-gray-400'}`}>
        <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-2 transition-all
          ${activeStep === step ? 'bg-emerald-600 text-white shadow-lg shadow-emerald-200' :
            activeStep > step ? 'bg-emerald-100 text-emerald-600' : 'bg-gray-100 text-gray-400'}`}>
          <Icon className="w-7 h-7" />
        </div>
        <span className="text-xs font-medium">{title}</span>
      </div>
    );
  };



  const renderStepContent = () => {
    switch (activeStep) {
      case 1:
        return (
          <>

            <div>
              <div className="min-h-screen w-full   ">
                <ToastContainer />
                <div className="md:max-w-7xl w-full  ">
                  {/* Header Section */}
                  <div className="text-center mb-12 space-y-4">
                    <h1 className="text-4xl md:text-5xl font-bold text-gray-800 tracking-tight">
                      Design Your <span className="text-emerald-600">Perfect</span> Meal Plan
                    </h1>
                    <p className="text-gray-600 max-w-2xl mx-auto text-lg">
                      Customize your nutrition journey with our chef-crafted meal packages
                    </p>
                  </div>

                  {/* Package Selection Section */}
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
                    {selectedPlans && selectedPlans.packages &&
                      // First group packages by packageGroup (supports string or array)
                      Object.entries(
                        selectedPlans.packages.reduce((groups, packageItem) => {
                          const groupArray = Array.isArray(packageItem.packageGroup)
                            ? packageItem.packageGroup
                            : [packageItem.packageGroup]; // always work with an array

                          groupArray.forEach(group => {
                            if (!groups[group]) {
                              groups[group] = [];
                            }
                            groups[group].push(packageItem);
                          });

                          return groups;
                        }, {})
                      )
                        // Sort the groups in the desired order
                        .sort(([groupNameA], [groupNameB]) => {
                          const order = {
                            'Full Package': 1,
                            'Main Meals with Breakfast': 2,
                            'Main Meals with FITT Snacks': 3
                          };

                          const normalizedA = groupNameA.toLowerCase();
                          const normalizedB = groupNameB.toLowerCase();

                          const aOrder = Object.entries(order).find(([key]) =>
                            key.toLowerCase() === normalizedA
                          )?.[1] || 4;

                          const bOrder = Object.entries(order).find(([key]) =>
                            key.toLowerCase() === normalizedB
                          )?.[1] || 4;

                          return aOrder - bOrder;
                        })
                        // Then map the sorted groups
                        ?.map(([groupName, packages]) => {
                          // Sort packages within each group if needed
                          const sortedPackages = [...packages].sort((a, b) => {
                            const aName = a.packageName.toLowerCase();
                            const bName = b.packageName.toLowerCase();
                            const order = {
                              'fullpackage': 1,
                              'main meals with breakfast': 2,
                              'main meals with fitt snacks': 3
                            };
                            const aOrder = order[aName] || 4;
                            const bOrder = order[bName] || 4;
                            return aOrder - bOrder;
                          });

                          return (
                            <div
                              key={groupName}
                              className="bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 overflow-hidden group"
                            >
                              <div className="h-3 bg-gradient-to-r from-emerald-400 to-teal-500"></div>
                              <div className="p-8">
                                <div className="flex items-start justify-between mb-6">
                                  <div className="p-3 bg-emerald-100 rounded-xl">
                                    <ShoppingBag className="w-6 h-6 text-emerald-600" />
                                  </div>
                                  <span className="text-sm font-medium text-emerald-600 bg-emerald-50 px-3 py-1 rounded-full">
                                    Perfect for {groupName === "Family" ? "families" : "individuals"}
                                  </span>
                                </div>

                                <h3 className="text-2xl font-bold mb-3 text-gray-800">{groupName}</h3>

                                <div className="space-y-3">
                                  {sortedPackages?.map(packageItem => {
                                    const packageKey = `${groupName}-${packageItem._id}`;

                                    return (
                                      <button
                                        key={packageKey}
                                        onClick={() => handleSelection(packageKey, packageItem.identifier)}
                                        className={`w-full py-3 px-6 rounded-xl text-left font-medium transition-all duration-300
                        ${selectedPackageId === packageKey
                                            ? "bg-gradient-to-r from-emerald-600 to-teal-500 text-white shadow-md"
                                            : "bg-emerald-50 text-emerald-700 hover:bg-emerald-100"
                                          }`}
                                      >
                                        <div className="flex justify-between items-center">
                                          <span>{packageItem.packageName}</span>
                                          <ChevronRight
                                            className={`w-5 h-5 ${selectedPackageId === packageKey ? "rotate-90" : ""
                                              }`}
                                          />
                                        </div>
                                      </button>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                  </div>


                  {/* Duration Selection */}
                  <div className="bg-white rounded-2xl shadow-xl p-8 mb-16">
                    <h2 className="text-2xl font-bold mb-8 text-gray-800">Select Your Plan Duration</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {plans?.map((plan) => (
                        <button
                          key={plan}
                          onClick={() => setSelectedPlan(plan)}
                          className={`p-6 rounded-xl transition-all duration-300 group relative overflow-hidden
                        ${selectedPlan === plan
                              ? "bg-gradient-to-r from-emerald-600 to-teal-500 text-white shadow-lg"
                              : "bg-gray-50 text-gray-700 hover:shadow-md"
                            }`}
                        >
                          <div className="absolute inset-0 bg-gradient-to-r from-emerald-600 to-teal-500 opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
                          <div className="flex justify-between items-center">
                            <div className="text-lg font-bold">{plan}</div>
                            {selectedPlan === plan && <div className="w-6 h-6 bg-white rounded-full flex items-center justify-center text-emerald-600">✓</div>}
                          </div>
                        </button>
                      ))}
                    </div>
                  </div>


                </div>
              </div>


            </div>


            {/* Calendar Section */}
            <div className="rounded-2xl shadow-xl  mb-16 p-4 ">
              <div className="flex justify-between items-center mb-8 ">
                <h2 className="text-2xl font-bold text-gray-800">Choose Your Start Date</h2>
                <div className="flex items-center space-x-4 ">
                  <button
                    onClick={handlePrevMonth}
                    className="p-2 rounded-full hover:bg-emerald-100 transition-colors"
                  >
                    <ChevronLeft className="w-6 h-6 text-emerald-600" />
                  </button>

                  <span className="font-medium text-gray-800">
                    {new Date(currentYear, currentMonth).toLocaleDateString('default', { month: 'long', year: 'numeric' })}
                  </span>

                  <button
                    onClick={handleNextMonth}
                    className="p-2 rounded-full hover:bg-emerald-100 transition-colors"
                  >
                    <ChevronRight className="w-6 h-6 text-emerald-600" />
                  </button>
                </div>
              </div>

              <div className="flex flex-col md:flex-row gap-8 md:p-8  ">
                {renderCalendar(0)}
                {renderCalendar(1)}
              </div>

              {/* Reset Selections Button */}
              <div className="flex justify-end mt-8">
                <button
                  onClick={handleResetSelections}
                  className="px-6 py-3 border-2 border-emerald-600 text-emerald-600 rounded-xl hover:bg-emerald-50 font-medium transition-all duration-300"
                >
                  Reset Selections
                </button>
              </div>
            </div>
            <div className="text-right">
              <button
                onClick={handleContinue} // Replace with your actual handler
                className="px-6 py-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl font-semibold shadow-md transition"
              >
                Continue
              </button>
            </div>
          </>
        );

      case 2:
        if (!selectedDate && selectedDates.length > 0) {
          setSelectedDate(selectedDates[0]);
        }

        return (
          <div className="min-h-screen bg-gradient-to-b from-emerald-50 to-white p-3 sm:p-4 md:p-6">
            <ToastContainer />
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col md:flex-row justify-between items-start gap-3 mb-4 md:mb-6">
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-1 md:mb-2">Customize Your Meals</h2>
                  <p className="text-sm md:text-base text-gray-600">
                    Select your favorite meals for each day of your plan
                  </p>
                </div>
                <div className="bg-emerald-50 rounded-xl p-3 w-full md:w-auto mt-2 md:mt-0">
                  <p className="text-xs md:text-sm font-medium text-emerald-700">
                    You can swap pre-selected favorites for any meal that suits your taste
                  </p>
                </div>
              </div>

              <div className="bg-white rounded-lg md:rounded-2xl shadow-md md:shadow-xl md:p-6 mb-8">

                {/* Date selection */}
                <div className="flex gap-2 overflow-x-auto mb-4 md:mb-6 pb-2 scrollbar-thin scrollbar-thumb-emerald-200 scrollbar-track-gray-100">
                  {selectedDates?.map((date) => (
                    <button
                      key={date}
                      onClick={() => setSelectedDate(date)}
                      className={`px-3 md:px-6 py-2 md:py-3 rounded-lg md:rounded-xl text-sm md:text-base font-medium whitespace-nowrap transition-all duration-300 ${date === selectedDate
                        ? "bg-gradient-to-r from-emerald-600 to-teal-500 text-white shadow-md"
                        : "border border-gray-200 text-gray-700 hover:bg-emerald-50 hover:border-emerald-200"
                        }`}
                    >
                      {new Date(date).toLocaleDateString("en-US", {
                        weekday: "short",
                        month: "short",
                        day: "numeric",
                      })}
                    </button>
                  ))}
                </div>

                {/* Meal types */}
                <div className="flex flex-col gap-6">
                  {selectedDate && mealType
                    ? mealType.map((type) => {
                      const meals = getMealsByType(type.identifier); // returns array filtered by selectedDate + mealType
                      if (!meals || meals.length === 0) return null;

                      return (
                        <div key={type.identifier} className="space-y-2">
                          {/* Meal type header */}
                          <h3 className="text-lg font-semibold">{type.mealType}</h3>

                          {/* Meal cards */}
                          <div className="grid grid-cols-2 md:grid-cols-4 pb-4 gap-3 md:gap-5">
                            {meals.map((meal) => (
                              <div
                                key={meal._id}
                                className="snap-start flex-shrink-0 w-full sm:w-full md:w-full"
                              >
                                <div
                                  className={`rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all duration-300 bg-white group cursor-pointer ${
                                    // highlight only when this meal is selected for the current type slot
                                    selectedMeals[selectedDate]?.some((m) => m._id === meal._id && m.selectedSlot === type.identifier)
                                      ? "ring-2 ring-emerald-500"
                                      : ""
                                    }`}
                                  onClick={() => {
                                    // Pass the specific meal type identifier for this slot (e.g., "breakfast", "main_meal_1")
                                    handleMealSelection(selectedDate, meal, type.identifier);
                                    // alert(type.identifier) // debug
                                  }
                                  }
                                >
                                  <div className="h-40 md:h-48 overflow-hidden relative">
                                    {meal.image?.length > 0 ? (
                                      <img
                                        src={meal.image[0]}
                                        alt={meal.mealName}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.style.display = 'none';
                                          e.target.parentNode.innerHTML += `
                                            <div class="w-full h-full bg-gradient-to-br from-emerald-50 to-teal-100 flex flex-col items-center justify-center">
                                              <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-emerald-300 mb-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                              </svg>
                                              <span class="text-emerald-400 text-xs font-medium">No Image</span>
                                            </div>`;
                                        }}
                                      />
                                    ) : (
                                      <div className="w-full h-full bg-gradient-to-br from-emerald-50 to-teal-100 flex flex-col items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-emerald-300 mb-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                        </svg>
                                        <span className="text-emerald-400 text-xs font-medium">No Image</span>
                                      </div>
                                    )}


                                    {selectedMeals[selectedDate]?.some(
                                      (m) => m._id === meal._id && m.selectedSlot === type.identifier
                                    ) && (
                                        <div className="absolute top-2 right-2 bg-emerald-500 text-white p-1 rounded-full flex items-center justify-center">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-4 w-4"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                              clipRule="evenodd"
                                            />
                                          </svg>
                                        </div>
                                      )}
                                  </div>

                                  <div className="p-3 md:p-4">
                                    <div className="flex justify-between items-start mb-2">
                                      <h3 className="text-lg font-bold text-gray-800 line-clamp-1">
                                        {meal.mealName || "Unnamed Meal"}
                                      </h3>
                                      {meal.foodType && (
                                        <div className={`mt-1 flex items-center gap-1.5`}>
                                          <div className={`w-2.5 h-2.5 rounded-full border border-white shadow-sm ${meal.foodType.toLowerCase() === 'veg' ? 'bg-green-500' :
                                            meal.foodType.toLowerCase() === 'non-veg' ? 'bg-red-500' :
                                              'bg-yellow-500'
                                            }`}></div>
                                          <span className="text-[10px] font-bold uppercase tracking-wider text-gray-500">
                                            {meal.foodType}
                                          </span>
                                        </div>
                                      )}
                                      <button
                                        onClick={(e) => toggleNutritionDetails(meal, e)}
                                        className="p-1 rounded-full hover:bg-gray-100 transition-colors"
                                        title="View portion details"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          className="h-5 w-5 text-emerald-600"
                                          viewBox="0 0 20 20"
                                          fill="currentColor"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2h-1v-3a1 1 0 00-1-1z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                      </button>
                                    </div>

                                    <p className="text-sm text-gray-600 mb-2 line-clamp-2">
                                      {meal.description || "No description available"}
                                    </p>

                                    {/* Portion & Nutrition Details Modal */}
                                    {showNutritionDetails[meal._id] && selectedMealForDetails && (
                                      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6">
                                        {/* Dark overlay with blur */}
                                        <div
                                          className="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setShowNutritionDetails(prev => ({ ...prev, [meal._id]: false }));
                                          }}
                                        ></div>

                                        {/* Modal Card */}
                                        <div className="relative w-full max-w-md bg-white rounded-3xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh] animate-in fade-in zoom-in duration-300">

                                          {/* Header Image Section */}
                                          <div className="relative h-64 sm:h-72 shrink-0">
                                            <img
                                              src={selectedMealForDetails.image?.[0] || "https://source.unsplash.com/random/800x600/?food"}
                                              alt={selectedMealForDetails.mealName}
                                              className="w-full h-full object-cover"
                                            />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>

                                            <button
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setShowNutritionDetails(prev => ({ ...prev, [meal._id]: false }));
                                              }}
                                              className="absolute top-4 right-4 bg-white/20 hover:bg-white/40 backdrop-blur-md text-white p-2 rounded-full transition-all duration-200"
                                            >
                                              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                              </svg>
                                            </button>

                                            <div className="absolute bottom-0 left-0 p-6 w-full">
                                              <h3 className="text-3xl font-bold text-white mb-1 shadow-sm leading-tight">
                                                {selectedMealForDetails.mealName || "Delicious Meal"}
                                              </h3>
                                              {selectedMealForDetails.foodType && (
                                                <div className="flex items-center gap-2 mt-2">
                                                  <span className={`px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-[0.1em] border backdrop-blur-md shadow-sm ${selectedMealForDetails.foodType.toLowerCase() === 'veg'
                                                    ? 'bg-green-500/20 text-green-300 border-green-500/30'
                                                    : selectedMealForDetails.foodType.toLowerCase() === 'non-veg'
                                                      ? 'bg-red-500/20 text-red-300 border-red-500/30'
                                                      : 'bg-yellow-500/20 text-yellow-300 border-yellow-500/30'
                                                    }`}>
                                                    {selectedMealForDetails.foodType}
                                                  </span>
                                                </div>
                                              )}
                                            </div>
                                          </div>

                                          {/* Scrollable Content */}
                                          <div className="flex-1 overflow-y-auto p-6 space-y-8
                                [&::-webkit-scrollbar]:w-2
                                [&::-webkit-scrollbar-track]:bg-transparent
                                [&::-webkit-scrollbar-thumb]:bg-gray-200
                                [&::-webkit-scrollbar-thumb]:rounded-full
                                hover:[&::-webkit-scrollbar-thumb]:bg-gray-300">

                                            {/* Description */}
                                            <div>
                                              <h4 className="flex items-center text-lg font-bold text-gray-800 mb-3">
                                                <Info className="w-5 h-5 mr-2 text-lime-600" />
                                                About this Meal
                                              </h4>
                                              <p className="text-gray-600 leading-relaxed text-sm sm:text-base bg-gray-50 p-4 rounded-2xl border border-gray-100">
                                                {selectedMealForDetails.description || "A chef-curated meal designed for optimal nutrition and taste. Enjoy a balance of healthy ingredients."}
                                              </p>
                                            </div>

                                            {/* Portion Information */}
                                            {selectedMealForDetails.portionDetails && (
                                              <div>
                                                <h4 className="flex items-center text-lg font-bold text-gray-800 mb-4">
                                                  <Scale className="w-5 h-5 mr-2 text-lime-600" />
                                                  Portion Facts
                                                </h4>
                                                <div className="grid grid-cols-2 gap-4">

                                                  <div className="bg-lime-50 p-4 rounded-2xl text-center border border-lime-100">
                                                    <div className="flex justify-center mb-1"><Flame size={16} className="text-lime-600" fill="currentColor" /></div>
                                                    <p className="text-xs text-lime-600 font-bold uppercase tracking-wider mb-1">Calories</p>
                                                    <p className="text-2xl font-black text-gray-800">{selectedMealForDetails.portionDetails.caloriesPerPortion || 0}</p>
                                                    <p className="text-xs text-gray-500">kcal</p>
                                                  </div>


                                                  <div className="bg-gray-50 p-4 rounded-2xl text-center border border-gray-100">
                                                    <div className="flex justify-center mb-1"><Activity size={16} className="text-blue-500" /></div>
                                                    <p className="text-xs text-gray-500 font-bold uppercase tracking-wider mb-1">Protein</p>
                                                    <p className="text-xl font-bold text-gray-800">{selectedMealForDetails.portionDetails.proteinPerPortion || 0}g</p>
                                                  </div>


                                                  <div className="bg-gray-50 p-4 rounded-2xl text-center border border-gray-100">
                                                    <div className="flex justify-center mb-1"><Leaf size={16} className="text-green-500" /></div>
                                                    <p className="text-xs text-gray-500 font-bold uppercase tracking-wider mb-1">Carbs</p>
                                                    <p className="text-xl font-bold text-gray-800">{selectedMealForDetails.portionDetails.carbsPerPortion || 0}g</p>
                                                  </div>


                                                  <div className="bg-gray-50 p-4 rounded-2xl text-center border border-gray-100">
                                                    <div className="flex justify-center mb-1"><Activity size={16} className="text-yellow-500" /></div>
                                                    <p className="text-xs text-gray-500 font-bold uppercase tracking-wider mb-1">Fat</p>
                                                    <p className="text-xl font-bold text-gray-800">{selectedMealForDetails.portionDetails.fatPerPortion || 0}g</p>
                                                  </div>


                                                  <div className="bg-gray-50 p-4 rounded-2xl text-center border border-gray-100">
                                                    <div className="flex justify-center mb-1"><Scale size={16} className="text-gray-400" /></div>
                                                    <p className="text-xs text-gray-500 font-bold uppercase tracking-wider mb-1">Weight</p>
                                                    <p className="text-xl font-bold text-gray-800">{selectedMealForDetails.portionDetails.weight || 0}g</p>
                                                  </div>


                                                  <div className="bg-gray-50 p-4 rounded-2xl text-center border border-gray-100">
                                                    <div className="flex justify-center mb-1"><Utensils size={16} className="text-gray-400" /></div>
                                                    <p className="text-xs text-gray-500 font-bold uppercase tracking-wider mb-1">Portion Count</p>
                                                    <p className="text-xl font-bold text-gray-800">{selectedMealForDetails.portionDetails.numberOfPortions || selectedMealForDetails.portionDetails.portion || 1}</p>
                                                  </div>


                                                  <div className="bg-gray-50 p-4 rounded-2xl text-center border border-gray-100">
                                                    <div className="flex justify-center mb-1"><Utensils size={16} className="text-gray-400" /></div>
                                                    <p className="text-xs text-gray-500 font-bold uppercase tracking-wider mb-1">Serving Size</p>
                                                    <p className="text-xl font-bold text-gray-800">{selectedMealForDetails.portionDetails.servingSize || "-"}</p>
                                                  </div>
                                                </div>
                                              </div>
                                            )}

                                            {/* Nutrition Information */}
                                            <div>
                                              <h4 className="flex items-center text-lg font-bold text-gray-800 mb-4">
                                                <Utensils className="w-5 h-5 mr-2 text-lime-600" />
                                                Nutrition Profile
                                              </h4>
                                              <div className="grid grid-cols-2 gap-3">
                                                {selectedMealForDetails.moreDetails && Object.entries(selectedMealForDetails.moreDetails).map(([key, value]) => (
                                                  <div key={key} className="flex justify-between items-center p-3 rounded-xl bg-white border border-gray-100 shadow-sm">
                                                    <span className="text-sm font-medium text-gray-500 capitalize">{key.replace(/([A-Z])/g, ' $1').trim()}</span>
                                                    <span className="font-bold text-gray-800">{value}</span>
                                                  </div>
                                                ))}
                                              </div>
                                            </div>

                                          </div>

                                          {/* Footer/Action (Optional) */}
                                          {/* <div className="p-4 bg-gray-50 border-t border-gray-100 text-center">
                              <span className="text-xs text-gray-400">DailyFit Nutrition Info</span>
                            </div> */}

                                        </div>
                                      </div>
                                    )}
                                    {/* Allergens Section */}
                                    {meal.moreDetails?.allergens?.length > 0 && (
                                      <div className="mt-2 pt-2 border-t border-gray-200">
                                        <h4 className="font-medium text-sm text-gray-700 mb-1">
                                          Allergens
                                        </h4>
                                        <div className="flex flex-wrap gap-1">
                                          {meal.moreDetails.allergens.map((allergen, index) => (
                                            <span
                                              key={index}
                                              className="inline-block bg-gray-100 text-gray-800 text-xs px-2 py-1 rounded"
                                            >
                                              {allergen}
                                            </span>
                                          ))}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      );
                    })
                    : null}


                </div>
              </div>



              {/* Confirm button */}
              <div className="flex justify-center mb-8 md:mb-12">
                <button
                  onClick={handleConfirmSelection}
                  className="px-6 md:px-8 py-3 md:py-4 bg-gradient-to-r from-emerald-600 to-teal-500 text-white font-bold text-base md:text-lg rounded-lg md:rounded-xl shadow-md hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300"
                >
                  Confirm Selection
                </button>
              </div>
            </div>
          </div>
        );

      case 3:
        return (
          <div className="flex flex-col">
            <h2 className="text-xl font-semibold text-gray-800 mb-6">
              Choose Your Add-ons <span className="text-sm text-gray-500">(Optional) If u dont need You can Skip!</span>
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {console.log(addons, "The addon list"
              )}
              {addons?.map((item) => {
                const isSelected = selectedEnhancements.some((selected) => selected._id === item._id);
                const selectedItem = selectedEnhancements.find((selected) => selected._id === item._id);
                const quantity = selectedItem ? selectedItem.quantity || 1 : 0;

                return (
                  <div
                    key={item._id}
                    className={`rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 relative group
                    ${isSelected ? "ring-2 ring-emerald-500" : ""}
                  `}
                    role="region"
                    aria-label={`${item.mealName} add-on option`}
                  >
                    <div className="h-40 overflow-hidden">
                      <img
                        src={item.image[0]}
                        alt={item.mealName}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-6 text-center">
                      <h3 className="text-lg font-bold text-gray-800 mb-1">{item.mealName}</h3>
                      <p className="text-emerald-600 font-medium">
                        AED {item.fareDetails.totalFare.toFixed(2)} / day
                      </p>

                      <div className="mt-4 flex items-center justify-center">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            if (quantity > 0) {
                              if (quantity === 1) {
                                handleRemoveAddOn(item);
                              } else {
                                handleQuantityChange(item, quantity - 1);
                              }
                            }
                          }}
                          className={`bg-emerald-500 hover:bg-emerald-600 text-white rounded-full w-8 h-8 flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-emerald-300 ${quantity === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
                          aria-label="Decrease quantity"
                          disabled={quantity === 0}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z" clipRule="evenodd" />
                          </svg>
                        </button>
                        <span className="mx-3 font-medium text-gray-700 min-w-[24px] text-center">{quantity}</span>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            if (quantity === 0) {
                              handleSelectionAddOn(item);
                            } else {
                              handleQuantityChange(item, quantity + 1);
                            }
                          }}
                          className="bg-emerald-500 hover:bg-emerald-600 text-white rounded-full w-8 h-8 flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-emerald-300"
                          aria-label="Increase quantity"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
                          </svg>
                        </button>
                      </div>
                    </div>

                    {isSelected && (
                      <div className="absolute top-3 right-3 bg-emerald-500 text-white p-1 rounded-full shadow-md">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            {/* Confirmation button */}
            {selectedEnhancements.length > 0 && (
              <div className="mt-8 flex justify-center">
                <button
                  onClick={handleConfirmAddOns}
                  className="py-3 px-8 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-base font-medium transition-all duration-300 shadow-md flex items-center space-x-2"
                  aria-label="Confirm selected add-ons"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span>Confirm Add-ons</span>
                </button>
              </div>
            )}
            <div className="mt-4 flex justify-center">
              <button
                onClick={handleSkip}
                className="py-3 px-8 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-base font-medium transition-all duration-300 shadow-md flex items-center space-x-2"
                aria-label="Skip add-ons"
              >
                Skip
              </button>
            </div>
          </div>
        );


      case 4:
        const uaeLocations = [
          "Abu Dhabi",
          "Dubai",
          "Sharjah",
          "Ajman",
          "Umm Al Quwain",
          "Ras Al Khaimah",
          "Fujairah",
          "Al Ain",
          "Ruwais",
          "Liwa Oasis",
          "Delma Island",
          "Sir Bani Yas Island"
        ];

        return (
          <div className="w-full mx-auto">
            {sessionStorage.getItem('userType') === '1' ? (
              <>
                <ToastContainer />
                <div className="mb-6 text-center">
                  {/* <h2 className="text-2xl font-bold text-gray-800 mb-2">Shipping Address</h2> */}
                  <p className="bg-yellow-100 text-green-700 font-semibold px-3 py-2 rounded-md mb-3">
                    If you have already added your address, you can skip this step
                  </p>
                  {/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && (
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                      <p className="text-blue-700 text-sm">
                        <Locate size={16} className="inline mr-1" />
                        <strong>Mobile detected:</strong> Your location will be automatically detected.
                        You can also search for a specific address or tap on the map to select your exact location.
                      </p>
                    </div>
                  )}
                </div>
                <form className="space-y-6" onSubmit={handleAddressSubmit}>
                  {/* Location Map Section */}
                  <div className="col-span-2">
                    <AddressLocationPicker
                      onLocationSelect={(location) => {
                        console.log('Location updated in parent:', location);
                        setFormData(prev => ({
                          ...prev,
                          latitude: location.latitude,
                          longitude: location.longitude,
                          streetName: location.streetName || prev.streetName,
                          isStreetManual: false
                        }));
                      }}
                    />
                  </div>

                  <div className="grid grid-cols-2 gap-6">
                    <div className="col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Selected Location {isLoadingAddress && <span className="text-gray-500 text-xs">(Loading...)</span>}
                      </label>
                      {/* <div className="relative">
                        <input
                          type="text"
                          name="location"
                          value={formData.location || ''}
                          readOnly
                          className="w-full px-4 py-2 rounded-xl border-2 border-green-300 bg-green-50 focus:border-green-500 cursor-not-allowed"
                          placeholder={isLoadingAddress ? 'Loading address...' : 'Click on the map to select a location'}
                          required
                        />
                        {formData.latitude && formData.longitude && (
                          <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                            <MapPin className="h-4 w-4 text-gray-400" />
                          </div>
                        )}
                      </div>
                       */}
                      {pinnedLocations.length > 0 && (
                        <div className="mt-3">
                          <p className="text-xs font-medium text-gray-500 mb-2">Recent locations:</p>
                          <div className="space-y-2 max-h-40 overflow-y-auto pr-2">
                            {pinnedLocations.map((loc, index) => (
                              <div
                                key={index}
                                onClick={() => {
                                  // Update form data
                                  setFormData(prev => ({
                                    ...prev,
                                    location: loc.address,
                                    street: loc.street || loc.address,
                                    latitude: loc.lat,
                                    longitude: loc.lng
                                  }));

                                  // Update map center
                                  setMapCenter({ lat: loc.lat, lng: loc.lng });

                                  // Close the dropdown if open
                                  setShowPinnedLocations(false);

                                  // Show success message
                                  toast.success('Location updated!');
                                }}
                                className="p-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg cursor-pointer border border-gray-100 flex items-start gap-2 transition-colors"
                              >
                                <MapPin size={16} className="text-blue-500 mt-0.5 flex-shrink-0" />
                                <div>
                                  <div className="font-medium">{loc.address.split(',')[0]}</div>
                                  <div className="text-xs text-gray-500 line-clamp-1">
                                    {loc.address.split(',').slice(1).join(',').trim()}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="col-span-2">
                      <div className="flex justify-between items-center mb-2">

                        <label className="block text-sm font-medium text-gray-700">
                          Street Name {formData.location && (
                            <span className="text-xs font-normal text-gray-500 ml-1">
                              (from {formData.isStreetManual ? 'manual entry' : 'map'})
                            </span>
                          )}
                        </label>
                        {!formData.isStreetManual && (
                          <button
                            type="button"
                            onClick={() => setFormData(prev => ({
                              ...prev,
                              isStreetManual: true,
                              street: prev.street || ''
                            }))}
                            className="text-xs text-blue-600 hover:underline"
                          >
                            Edit manually
                          </button>
                        )}
                      </div>
                      <div className="relative">
                        <input
                          type="text"
                          name="streetName"
                          value={formData.streetName || ''}
                          onChange={handleStreetNameChange}
                          readOnly={!formData.isStreetManual}
                          className={`w-full px-4 py-2 pr-10 rounded-xl border-2 ${formData.isStreetManual
                            ? 'border-blue-300 bg-white focus:border-blue-500'
                            : 'border-green-300 bg-green-50 focus:border-green-500 cursor-not-allowed'
                            }`}
                          placeholder={formData.isStreetManual ? 'Enter street name' : 'Auto-filled from map'}
                        />
                        {!formData.isStreetManual && (
                          <button
                            type="button"
                            onClick={() => setFormData(prev => ({
                              ...prev,
                              isStreetManual: true
                            }))}
                            className="absolute inset-y-0 right-0 px-3 flex items-center text-blue-600 hover:text-blue-800"
                            title="Edit manually"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                              <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                            </svg>
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-2">Building Name</label>
                      <input
                        type="text"
                        name="buildingName"
                        value={formData.buildingName}
                        onChange={handleChange}
                        className="w-full px-4 py-2 rounded-xl border-2 border-gray-200 focus:border-purple-500 focus:ring-0"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">House/Flat Number</label>
                      <input
                        type="text"
                        name="flatNumber"
                        value={formData.flatNumber}
                        onChange={handleChange}
                        className="w-full px-4 py-2 rounded-xl border-2 border-gray-200 focus:border-purple-500 focus:ring-0"
                      />
                    </div>
                    <div className="col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-2">Address Type</label>
                      <select
                        name="addressType"
                        value={formData.addressType}
                        onChange={handleChange}
                        className="w-full px-4 py-2 rounded-xl border-2 border-gray-200 focus:border-purple-500 focus:ring-0"
                      >
                        <option value="home">home</option>
                        <option value="work">work</option>
                      </select>
                    </div>
                    {/* <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">City</label>
                      <input
                        type="text"
                        name="city"
                        value={formData.city}
                        onChange={handleChange}
                        className="w-full px-4 py-2 rounded-xl border-2 border-gray-200 focus:border-purple-500 focus:ring-0"
                        required
                      />
                    </div> */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Emirate</label>
                      <select
                        name="city"
                        value={formData.city}
                        onChange={handleChange}
                        className="w-full px-4 py-2 rounded-xl border-2 border-gray-200 focus:border-purple-500 focus:ring-0"
                        required
                      >
                        <option value="">Select Emirate</option>
                        {uaeLocations.map((location) => (
                          <option key={location} value={location}>
                            {location}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-2">Landmark (Optional)</label>
                      <input
                        type="text"
                        name="landmark"
                        value={formData.landmark}
                        onChange={handleChange}
                        className="w-full px-4 py-2 rounded-xl border-2 border-gray-200 focus:border-purple-500 focus:ring-0"
                        placeholder="E.g., Near Dubai Mall, Next to Metro Station"
                      />
                    </div>
                    <div className="col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number</label>
                      <input
                        type="tel"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        className="w-full px-4 py-2 rounded-xl border-2 border-gray-200 focus:border-purple-500 focus:ring-0"
                        required
                      />
                    </div>
                  </div>

                  <div className="flex space-x-4">
                    <button
                      type="button"
                      onClick={async (e) => {
                        e.preventDefault();
                        saveSelectionsToSessionStorage();
                        const isSuccess = await handleAddressSubmit(e);
                        if (isSuccess) {
                          handleCompleteOrder();
                        }
                      }}
                      className="flex-1 bg-[#059033] text-white py-3 rounded-xl font-medium transition hover:bg-[#047029]"
                    >
                      Submit Address
                    </button>

                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        saveSelectionsToSessionStorage();
                        handleCompleteOrder();
                      }}
                      className="flex-1 bg-gray-200 text-gray-800 py-3 rounded-xl font-medium transition hover:bg-gray-300"
                    >
                      Skip
                    </button>
                  </div>
                </form>
              </>
            ) : (
              <div className="text-center py-10">
                <div className="mb-6">
                  <h2 className="text-2xl font-bold text-gray-800 mb-2">Please Login to Continue</h2>
                  <p className="text-gray-600">You need to be logged in to access this feature</p>
                </div>
                <button
                  onClick={() => window.location.href = '/Order'}
                  className="bg-[#059033] text-white py-3 px-8 rounded-xl font-medium transition hover:bg-[#047029]"
                >
                  Go to Login
                </button>
              </div>
            )}
          </div>
        );

    }
  };
  const handleConfirmSelection = () => {
    if (selectedDates.length === 0) {
      console.warn("No dates selected");
      return;
    }


    const startDate = selectedDates[0];
    const endDate = selectedDates[selectedDates.length - 1];

    const selectedMealsArray = selectedDates?.map((date) => ({
      date,
      // Ensure `meals` is an array of meal objects (avoid nested arrays)
      meals: selectedMeals[date]
        ? (Array.isArray(selectedMeals[date]) ? selectedMeals[date] : [selectedMeals[date]])
        : [],
    }));

    const formattedData = {
      selectedMeals: selectedMealsArray,
    };
    toast.success("Menu added successfully!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
    console.log("Selected Products:", formattedData);
    console.log("Start Date:", startDate);
    console.log("End Date:", endDate);
    sessionStorage.setItem("selectedProducts", JSON.stringify(formattedData));
    sessionStorage.setItem("startDate", startDate);
    sessionStorage.setItem("endDate", endDate);
    setTimeout(() => {
      setActiveStep(3);
    }, 1600);

    // console.log("Selected Meals:", JSON.stringify(formattedData, null, 2));
  };

  const handleBackClick = () => {
    // Determine the previous step based on current step
    const previousStep = Math.max(1, activeStep - 1);

    // Reset any necessary state for the previous step
    switch (previousStep) {
      case 1:
        // If going back to step 1, you might want to reset some selections
        setSelectedPackageId(null);
        setSelectedPlan(null);
        break;
      case 2:
        // If going back to step 2, reset meal selections if needed
        setSelectedDate(null);
        setSelectedMeals({});
        break;
      case 3:
        // If going back to step 3, reset enhancements
        setSelectedEnhancements([]);
        break;
    }

    // Set the active step to the previous step
    setActiveStep(previousStep);
  };


  return (

    <div className="min-h-screen bg-gray-50 p-6">
      <div className="md:max-w-6xl w-full mx-auto">
        {/* Progress Steps */}
        <div className="flex flex-wrap justify-between items-center mb-12 gap-2 w-full">
          {[1, 2, 3, 4]?.map((step) => (
            <div key={step} className="flex items-center">
              <div className={`w-8 h-8 sm:w-10  gap-2 sm:h-10 rounded-full sm:rounded-xl flex items-center justify-center font-semibold text-sm sm:text-base
        ${activeStep >= step ? 'bg-[#059033] text-white' : 'bg-gray-200 text-gray-600'}`}>
                {step}
              </div>
              {step <= 4 && (
                <div className={`w-12 sm:w-16 md:w-24 h-1 mx-1 sm:mx-2
          ${activeStep > step ? 'bg-[#059033]' : 'bg-gray-200'}`}
                />
              )}
            </div>
          ))}
        </div>

        {/* Step Content */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold mb-2">
            {activeStep === 1 ? 'Choose Your Plan' :
              activeStep === 2 ? 'Select Your Meals' :
                activeStep === 3 ? 'Enhancement Products' :
                  'Delivery Details'}
          </h2>
          <p className="text-gray-600">
            {activeStep === 1 ? 'Select a meal plan that fits your lifestyle' :
              activeStep === 2 ? 'Customize your weekly menu' :
                activeStep === 3 ? 'Add your Addon Products' :
                  'Where should we deliver your meals? '}
          </p>
        </div>

        {renderStepContent()}
      </div>
    </div>
  );
};

export default MealPlanner;